import React, { useContext, useMemo } from 'react'
import styles from '../styles.module.scss'
import { WebLessonsContext } from '../../../utils/context'
import { AudioComponent, VideoComponent } from '../../../components/LivekitComponents'


const MainBlock = () => {
  
  const { participants } = useContext(WebLessonsContext)

  const teacherPart = useMemo(() => participants.find(p => p._attributes.position === 'teacher'), [participants])
  
  const [audioTrack] = Array.from(teacherPart?.audioTrackPublications.values() || [])
  const [videoTrack, shareTrack] = Array.from(teacherPart?.videoTrackPublications.values() || [])

  const video = shareTrack || videoTrack

  return (
    <div className={styles.mainBlock}>
      {video && <VideoComponent {...video}/>}
      {audioTrack && <AudioComponent {...audioTrack}/>}
    </div>
  )
}

export default MainBlock